import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { areEqual, deepCopy, DwComponent, DwComponentType, DwConfigService, DwContextService, DwEventService, DwExpressionService, DwExpressionStateService, DwFormContextMode, DwFormSectionComponent, DwMetaDataFormApi, DwMetaDataFormSectionStateService, DwMetaDataFormStateService, DwMetadataFormUtilService, DwMetadataFormValidationBuilderService, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AcsWrittenResultEntity, AppMetaDataItemNames, StudentCourseForContextQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { StudentCourseEndorsementContext } from '../../../courses/contexts/student-course-endorsement-context.service';
import { StudentRepositoryService } from '../../services/student-repository.service';



@DwComponent({
  key: 'courseAcsWrittenResults',
  name: 'Course ACS Written Results',
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Course,
  componentType: DwComponentType.formSection
})
@Component({
  selector: 'app-course-acs-written-results',
  templateUrl: './course-acs-written-results.component.html',
  styleUrls: ['./course-acs-written-results.component.scss']
})
export class CourseAcsWrittenResultsComponent extends DwSectionBaseComponent {
  studentCourseContext: StudentCourseForContextQueryEntity;
  acsWrittenResults: AcsWrittenResultEntity[];
  formApi: DwMetaDataFormApi;
  item = AppMetaDataItemNames.AcsWrittenResult;
  formMode = DwFormContextMode.edit;

  selectedAcsWrittenResult: AcsWrittenResultEntity;

  hideSelectedResult = false;

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private dwFormStateService: DwMetaDataFormStateService,
    private dwEventService: DwEventService,
    private studentRepositoryService: StudentRepositoryService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwFormStateService.state.formApi;

    this.dwFormStateService.state.formContext.contextMode = DwFormContextMode.view;
  }

  ngOnInit(): void {
    this.runAfterContextDataLoaded(StudentCourseEndorsementContext, true, (contextData) => this.initStudentCourseContext(contextData));

    this.setupEventHandlers();
  }

  setupEventHandlers(): void {
    // If the assignment is updated, we need to refresh any assignment student grids
    this.subscriptions.push(
      this.dwEventService.getEventData(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.AcsWrittenResult)).subscribe((event) => {
         this.loadAcsWrittenResults();
      })
    );
  }
  

  initStudentCourseContext(contextData: StudentCourseForContextQueryEntity): void {
    this.studentCourseContext = contextData;

    this.formApi.getContextData(StudentCourseEndorsementContext)
      .subscribe(contextData => {
        this.studentCourseContext = contextData;

        console.log('student Course Context Updated');

        this.loadAcsWrittenResults();
      });


    this.loadAcsWrittenResults();
  }

  onAcsWrittenResultChange(acsWrittenResult: AcsWrittenResultEntity): void {
    this.selectedAcsWrittenResult = acsWrittenResult;

    this.hideSelectedResult = true;

    setTimeout(() => {
      this.hideSelectedResult = false;
    }, 100);
  }

  private loadAcsWrittenResults(): void {
    if (!this.studentCourseContext?.RoStudentCourseAcsTestResultDetailACSTestResultCount) {
      return;
    }

    this.studentRepositoryService.getAcsWrittenResults(this.studentCourseContext.StudentCourseId)
      .subscribe(results => {
        this.acsWrittenResults = results;

        this.selectedAcsWrittenResult = this.acsWrittenResults.length > 0 ? this.acsWrittenResults[0] : null;

        this.updateStudentCourseContext();
      });
  }

 updateStudentCourseContext() {

    this.studentRepositoryService.getStudentCourseForContext(this.studentCourseContext.StudentCourseId)
      .subscribe(context => {
        if (areEqual(context, this.studentCourseContext)) {
          return;
        }
        
        this.studentCourseContext = context;
 
        this.formApi.patchContextData(StudentCourseEndorsementContext, context);
      });
    }
}
